import {useState} from "react";
import type {Recommendation} from "../model/types";
import {categoryLabel, categoryLabelClass} from "./labels";

type FeedbackHandler = (resultId: number, itemId: string, positive: boolean) => Promise<boolean>;

export function RecommendationCard({recommendation, onFeedback}: {recommendation: Recommendation; onFeedback: FeedbackHandler}) {
	const {item, userName, resultId} = recommendation;
	const [submitted, setSubmitted] = useState(false);
	const [pending, setPending] = useState(false);

	const sendFeedback = (positive: boolean) => {
		if (pending || submitted) {
			return;
		}
		setPending(true);
		onFeedback(resultId, item.id, positive)
			.then(ok => {
				if (ok) {
					setSubmitted(true);
				}
			})
			.finally(() => setPending(false));
	};

	return (
		<div className="panel panel-flat teamInsightsRecommendation">
			<div className="panel-body">
				<div className="teamInsightsRecommendation-header">
					<h6 className="teamInsightsRecommendation-title text-semibold no-margin-top">
						{item.title}
						<span className="text-muted text-size-small teamInsightsRecommendation-user">({userName})</span>
					</h6>
					<div className="teamInsightsRecommendation-labels">
						<span className={`label ${categoryLabelClass(item.category)}`}>{categoryLabel(item.category)}</span>
					</div>
				</div>

				<p className="teamInsightsRecommendation-summary">{item.summary}</p>

				<div className="teamInsightsRecommendation-feedback text-muted text-size-small">
					{submitted ? (
						<span>{messages["reports.teamInsights.feedback.thanks"]}</span>
					) : (
						<>
							<span className="teamInsightsRecommendation-feedbackLabel">{messages["reports.teamInsights.feedback.prompt"]}</span>
							<button type="button" className="btn btn-link btn-xs" disabled={pending}
									title={messages["reports.teamInsights.feedback.helpful"]}
									onClick={() => sendFeedback(true)}>
								<i className="icon-thumbs-up2"/>
							</button>
							<button type="button" className="btn btn-link btn-xs" disabled={pending}
									title={messages["reports.teamInsights.feedback.notHelpful"]}
									onClick={() => sendFeedback(false)}>
								<i className="icon-thumbs-down2"/>
							</button>
						</>
					)}
				</div>
			</div>
		</div>
	);
}
